import ApplicationConfig from '../providers/useConfig/ApplicationConfig';

const apiRoutes = () =>
    ApplicationConfig.api_config?.routes?.Api ?? ({} as { api_origin?: string; frontend_path?: string; project_path?: string });

export const apiOrigin = () => apiRoutes().api_origin;
export const frontendPath = () => apiRoutes().frontend_path;
export const projectPath = () => apiRoutes().project_path;

const originOf = (url?: string) => url?.match(/^https?:\/\/[^/]+/)?.[0] ?? '';

export const authSessionPath = () => `${apiOrigin()}/auth/realms/elamus/session`;
export const customerDetailsPath = () => `${originOf(projectPath())}/api/ext/customer-details`;
export const navigationPath = () => `${projectPath()}/navigation`;
export const channelsPath = () => `${projectPath()}/channels`;
export const channelGroups = () => `${projectPath()}/channel_groups`;
export const streamSessionPath = () => `${projectPath()}/sessions`;
export const purchasePath = () => `${projectPath()}/vod_purchases`;
export const accountPath = () => `${projectPath()}/account`;
export const changePinPath = () => `${projectPath()}/account/purchase_pin`;
export const validatePinPath = () => `${projectPath()}/account/purchase_pin/verification`;
export const guidePath = () => `${projectPath()}/guide`;
export const favoritesPath = () => `${projectPath()}/channel_favorites`;
export const myFavoritesPath = () => `${projectPath()}/bookmarks`;
export const playbackPositionsPath = () => `${projectPath()}/playback_positions`;
export const nowAndNextPath = () => `${projectPath()}/now_and_next`;
export const continueWatchingPath = () => `${projectPath()}/continue_watching`;
export const recordingsPath = () => `${projectPath()}/recordings`;
export const seriesRecordingsPath = () => `${projectPath()}/series_recordings`;
export const servicesPath = () => `${frontendPath()}/services`;
export const servicePurchasePath = () => `${frontendPath()}/services/purchase`;
export const searchPath = () => `${projectPath()}/search`;
export const watchlistPath = () => `${projectPath()}/watchlist`;

export const authSessionDevicePath = (deviceUuid: string) => `${authSessionPath()}/device/${deviceUuid}`;
export const authSessionIdPath = (sessionId: string) => `${authSessionPath()}/${sessionId}`;
export const vodPath = (vodId) => `${projectPath()}/vod_assets/${vodId}`;
export const programsPath = (programSeriesId) => `${projectPath()}/programs/${programSeriesId}`;
export const programSeriesPath = (programSeriesId: string) => `${projectPath()}/program_series/${programSeriesId}`;
export const programSeriesEpisodesPath = (programSeriesId) => `${projectPath()}/program_series/${programSeriesId}/episodes`;
export const trailerPath = (trailerId) => `${projectPath()}/play/trailer/${trailerId}`;
export const pagePath = (id: string) => `${projectPath()}/pages/${id}`;
export const collectionPath = (collectionId: string) => `${projectPath()}/collections/${collectionId}`;
export const streamSessionWithIdPath = (sessionId?: string) => `${projectPath()}/sessions${sessionId ? `/${sessionId}` : ''}`;
export const listingPath = (listingId: string) => `${projectPath()}/listings/${listingId}`;
export const listingFavoritePath = (listingId: string) => `${projectPath()}/listings/${listingId}/bookmark`;
export const listingPlaybackPositionsPath = (listingId: string) => `${projectPath()}/listings/${listingId}/playback_position`;
export const listingProgramFavoritePath = (programId: string) => `${projectPath()}/programs/${programId}/bookmark`;
export const VODPlaybackPositionsPath = (vodId: string) => `${projectPath()}/vod_assets/${vodId}/playback_position`;
export const VODSeriesPath = (vodSeriesId: string) => `${projectPath()}/vod_series/${vodSeriesId}`;
export const VODSeriesEpisodesPath = (vodSeriesId: string) => `${projectPath()}/vod_series/${vodSeriesId}/episodes`;
export const VODSeriesNextEpisodePath = (vodSeriesId: string) => `${projectPath()}/vod_series/${vodSeriesId}/next_episode`;
export const vodFavoritePath = (vodId: string) => `${projectPath()}/vod_assets/${vodId}/bookmark`;
export const vodSeriesPath = (vodId: string) => `${projectPath()}/vod_series/${vodId}/bookmark`;
export const programSeriesFavoritePath = (programId: string) => `${projectPath()}/program_series/${programId}/bookmark`;
export const programSeriesNextEpisodePath = (programId: string) => `${projectPath()}/program_series/${programId}/next_episode`;
export const recordingByIdPath = (recordingId: string) => `${projectPath()}/recordings/${recordingId}?recording_id=${recordingId}`;
export const seriesRecordingByIdPath = (seriesRecordingId: string) => `${projectPath()}/series_recordings/${seriesRecordingId}`;
